/* unplugin-vue-components disabled */import script from "./ModernPoster.vue?vue&type=script&setup=true&lang=js"
export * from "./ModernPoster.vue?vue&type=script&setup=true&lang=js"

import "./ModernPoster.vue?vue&type=style&index=0&id=9171af1e&scoped=true&lang=scss"

import exportComponent from "D:\\pangu_artificial_intelligence_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9171af1e"]])

export default __exports__